<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
</script>

<template>
  <div class="absolute right-4 top-[50%]" style="transform: translateY(-50%)">
    <SVG
      icon="fas-spinner-third"
      height="1.25rem"
      width="1.25rem"
      class="animate-spin text-neutral600"
    />
  </div>
</template>
